import { render, staticRenderFns } from "./updateXminfo.vue?vue&type=template&id=6af6cc56&scoped=true&"
import script from "./updateXminfo.vue?vue&type=script&lang=js&"
export * from "./updateXminfo.vue?vue&type=script&lang=js&"
import style0 from "./updateXminfo.vue?vue&type=style&index=0&id=6af6cc56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6cc56",
  null
  
)

export default component.exports